/**
 * 功能描述： js 获取的今天日期、本周、本月、本年起始和结束日期 <br>
 * 〈〉
 * @Author https://www.cnblogs.com/douyage/p/14173103.html
 * @Date 11:23 2021/1/26
 **/

/***
 * 功能描述：得到今天、昨天、明天日期 <br>
 * 〈〉
 * getDate(dates)  //dates为数字类型，0代表今日,-1代表昨日，1代表明日，返回yyyy-mm-dd格式字符串，dates不传默认代表今日。
 * @Param
 * @Return
 * @Author CHU
 * @Date 11:24 2021/1/26
 **/
export function getDate(dates) {
  var dd = new Date();
  var n = dates || 0;
  dd.setDate(dd.getDate() + n);
  var y = dd.getFullYear();
  var m = dd.getMonth() + 1;
  var d = dd.getDate();
  m = m < 10 ? "0" + m : m;
  d = d < 10 ? "0" + d : d;
  var day = y + "-" + m + "-" + d;
  return day;
}

/**
 * 功能描述：得到本周、上周、下周的起始、结束日期 <br>
 * 〈〉
 * getWeek(type,dates)  //type为字符串类型，有两种选择，"s"代表开始,"e"代表结束，dates为数字类型，不传或0代表本周，-1代表上周，1代表下周
 * getWeek("s",1)  //得到下周一的yyyy-mm-dd格式日期
 * getWeek("e",1)  //得到下周日的yyyy-mm-dd格式日期
 * @Param
 * @Return
 * @Author CHU
 * @Date 11:25 2021/1/26
 **/
export function getWeek(type, dates) {
  var now = new Date();
  var nowTime = now.getTime();
  var day = now.getDay();
  var longTime = 24 * 60 * 60 * 1000;
  var n = longTime * 7 * (dates || 0);
  var dd = 0;

  if (type == "s") {
    dd = nowTime - (day - 1) * longTime + n;
  }
  if (type == "e") {
    dd = nowTime + (7 - day) * longTime + n;
  }
  dd = new Date(dd);
  var y = dd.getFullYear();
  var m = dd.getMonth() + 1;
  var d = dd.getDate();
  m = m < 10 ? "0" + m : m;
  d = d < 10 ? "0" + d : d;
  day = y + "-" + m + "-" + d;
  return day;
}

/**
 * 功能描述：得到本月、上月、下月的起始、结束日期 <br>
 * 〈〉
 * getMonth(type,months)  //type为字符串类型，有两种选择，"s"代表开始,"e"代表结束，months为数字类型，不传或0代表本月，-1代表上月，1代表下月
 * getMonth("s",1)  //得到下月第一天的yyyy-mm-dd格式日期
 * getMonth("e",1)  //得到下月最后一天的yyyy-mm-dd格式日期
 * @Param
 * @Return
 * @Author CHU
 * @Date 11:25 2021/1/26
 **/
export function getMonth(type, months) {
  var d = new Date();
  var year = d.getFullYear();
  var month = d.getMonth() + 1;
  if (Math.abs(months) > 12) {
    months = months % 12;
  }
  if (months != 0) {
    if (month + months > 12) {
      year++;
      month = (month + months) % 12;
    } else if (month + months < 1) {
      year--;
      month = 12 + month + months;
    } else {
      month = month + months;
    }
  }
  month = month < 10 ? "0" + month : month;
  // var date = d.getDate();
  var firstday = year + "-" + month + "-" + "01";
  var lastday = "";
  if (
    month == "01" ||
    month == "03" ||
    month == "05" ||
    month == "07" ||
    month == "08" ||
    month == "10" ||
    month == "12"
  ) {
    lastday = year + "-" + month + "-" + 31;
  } else if (month == "02") {
    if (
      (year % 4 == 0 && year % 100 != 0) ||
      (year % 100 == 0 && year % 400 == 0)
    ) {
      lastday = year + "-" + month + "-" + 29;
    } else {
      lastday = year + "-" + month + "-" + 28;
    }
  } else {
    lastday = year + "-" + month + "-" + 30;
  }
  var day = "";
  if (type == "s") {
    day = firstday;
  } else {
    day = lastday;
  }
  return day;
}

/***
 * 功能描述：得到今年、去年、明年的开始、结束日期 <br>
 * 〈〉
 * getYear(type,dates)  //type为字符串类型，有两种选择，"s"代表开始,"e"代表结束，dates为数字类型，不传或0代表今年，-1代表去年，1代表明年
 * getYear("s",1)  //得到明年第一天的yyyy-mm-dd格式日期
 * getYear("e",1)  //得到明年最后一天的yyyy-mm-dd格式日期
 * @Param
 * @Return
 * @Author CHU
 * @Date 11:26 2021/1/26
 **/
export function getYear(type, dates) {
  var dd = new Date();
  var n = dates || 0;
  var year = dd.getFullYear() + Number(n);
  var day = "";
  if (type == "s") {
    day = year + "-01-01";
  }
  if (type == "e") {
    day = year + "-12-31";
  }
  if (!type) {
    day = year + "-01-01/" + year + "-12-31";
  }
  return day;
}

/**
 * 功能描述：今天开始或者结束时间 <br>
 * 〈〉
 * @Param
 * @Return
 * @Author CHU
 * @Date 11:42 2021/1/26
 **/
export function getCurDateTime(type) {
  if (type == "s") {
    return getDate(0) + " 00:00:00";
  }
  if (type == "e") {
    return getDate(0) + " 23:59:59";
  }
  return "";
}

/**
 * 功能描述：本周开始或者结束时间 <br>
 * 〈〉
 * @Param
 * @Return
 * @Author CHU
 * @Date 11:45 2021/1/26
 **/
export function getCurWeekTime(type) {
  if (type == "s") {
    return getWeek(type, 0) + " 00:00:00";
  }
  if (type == "e") {
    return getWeek(type, 0) + " 23:59:59";
  }
  return "";
}

/**
 * 功能描述：本月开始或者结束时间 <br>
 * 〈〉
 * @Param
 * @Return
 * @Author CHU
 * @Date 11:46 2021/1/26
 **/
export function getCurMonthTime(type) {
  if (type == "s") {
    return getMonth(type, 0) + " 00:00:00";
  }
  if (type == "e") {
    return getMonth(type, 0) + " 23:59:59";
  }
  return "";
}

/**
 * 功能描述：本年开始或者结束时间 <br>
 * 〈〉
 * @Param
 * @Return
 * @Author CHU
 * @Date 11:46 2021/1/26
 **/
export function getCurYearTime(type) {
  if (type == "s") {
    return getYear(type, 0) + " 00:00:00";
  }
  if (type == "e") {
    return getYear(type, 0) + " 23:59:59";
  }
  return "";
}

/**
 * 功能描述：根据开始结束时间获取月份列表 <br>
 *   getMonthList('2020-01-01 00:00:00', '2020-12-31 00:00:00')
 * 〈〉
 * @Param
 * @Return
 * @Author CHU
 * @Date 13:55 2021/1/26
 **/
export function getMonthList(start, end) {
  // 月份编号
  let MONTH = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12"
  ];

  // 返回列表
  let list = [];

  // 开始日期
  let s = new Date(start);
  // 结束日期
  let e = new Date(end);

  // 由于开始时间，可能晚于结束时间，因此需要做开始结束日期判断
  if (s > e) {
    let n = s;
    s = e;
    e = n;
  }

  // 开始年份
  let sYear = s.getFullYear();
  // 结束年份
  let eYear = e.getFullYear();
  // 开始月份
  let sMonth = s.getMonth() + 1;
  // 结束月份
  let eMonth = e.getMonth() + 1;

  // 同一年份
  if (sYear == eYear) {
    // 遍历月份
    for (let i = sMonth; i <= eMonth; i++) {
      list.push({ name: sYear + MONTH[i], value: i + "月" });
    }
  } else {
    // 不同年份

    // 遍历年份
    for (let y = sYear; y <= eYear; y++) {
      // 起始年份
      if (y == sYear) {
        // 遍历月份
        for (let m = sMonth; m <= 12; m++) {
          list.push({
            name: y + MONTH[m],
            value: getFmtYear(y) + "年" + m + "月"
          });
        }
      } else if (y == eYear) {
        // 结束年份
        for (let m = 1; m <= eMonth; m++) {
          list.push({
            name: y + MONTH[m],
            value: getFmtYear(y) + "年" + m + "月"
          });
        }
      } else {
        // 中间年份
        for (let m = 1; m <= 12; m++) {
          list.push({
            name: y + MONTH[m],
            value: getFmtYear(y) + "年" + m + "月"
          });
        }
      }
    }
  }

  return list;
}

/**
 * 功能描述：获取指定m个月份前的1日的时间 <br>
 * 〈〉
 * @Param  m 指定m个月前
 * @Return
 * @Author CHU
 * @Date 15:09 2021/1/26
 **/
export function getBeforeMonthTime(m) {
  // 月份编号
  let MONTH = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12"
  ];

  // 当前时间
  let now = new Date();

  // let month = now.getMonth() + 1;
  let month = now.getMonth();
  let year = now.getFullYear();

  if (month > m) {
    return year + "-" + MONTH[month - m] + "-01 00:00:00";
  } else {
    if (m > 12) {
      year = year - m / 12;
      let subM = m % 12;
      if (month > subM) {
        return year + "-" + MONTH[month - subM] + "-01 00:00:00";
      } else {
        return year - 1 + "-" + MONTH[12 - subM - month] + "-01 00:00:00";
      }
    } else {
      return year - 1 + "-" + MONTH[12 - m - month] + "-01 00:00:00";
    }
  }
}

/**
 * 功能描述：获取格式化的年，如：2021年，格式化后为 21 <br>
 * 〈〉
 * @Param
 * @Return
 * @Author CHU
 * @Date 14:29 2021/1/26
 **/
function getFmtYear(y) {
  let year = y % 100;

  if (year < 10) {
    return "0" + year;
  } else {
    return year;
  }
}
